<template>
  <div v-if="enabled">
    <div v-show="completed && canDelete">
      <img
        src="/images/attendee-dashboard/icons/check-blue.png"
        width="25"
        alt="Remove from My Agenda"
        @click.stop="$emit('updateScheduler')"
      />
    </div>

    <div v-show="!completed" >
      <img
        src="/images/attendee-dashboard/icons/plus.png"
        width="25"
        alt="Add to My Agenda"
        @click.stop="$emit('updateScheduler')"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: false
    },
    completed: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    showSchedulerIndicator: {
      type: Boolean,
      default: false
    }
  }
}
</script>
